import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'acl-installation-sub-nav',
  standalone: false,
  templateUrl: './installation-sub-nav.component.html',
  styleUrl: './installation-sub-nav.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstallationSubNavComponent {
  private readonly router = inject(Router);

  readonly navs = input<any>();

  menuItemClick(childUrl: string) {
    this.router.navigate(['/' + childUrl]);
  }
}
